import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/serviceWorkerRegistration";

// Suppress benign "ResizeObserver loop" errors from Recharts on mount.
// (1) Wrap the constructor so callbacks run in rAF (breaks the loop).
if (typeof window !== "undefined" && window.ResizeObserver) {
  const OriginalRO = window.ResizeObserver;
  window.ResizeObserver = class extends OriginalRO {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          try { callback(entries, observer); } catch (_) { /* swallow */ }
        });
      });
    }
  };
}
// (2) Also swallow any error/rejection that still bubbles up.
const RO_MSG = "ResizeObserver loop";
window.addEventListener(
  "error",
  (e) => {
    if (e.message && e.message.includes(RO_MSG)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);
window.addEventListener("unhandledrejection", (e) => {
  if (e.reason?.message?.includes?.(RO_MSG)) e.preventDefault();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

registerServiceWorker();
